export const fetcher = (url: string, new_options: any = {}) => {
  const headers = {
    'Content-Type': 'application/json'
  }
  const default_options = {method: 'GET', headers: headers, mode: 'cors', credentials: 'include'}
  const options = Object.assign(default_options, new_options)
  return fetch(url, options)
}
